import { InferGetServerSidePropsType } from 'next';

import config from 'config';
import withPageLayout from 'core/hocs/withPageLayout';
import { itShops } from 'consts/shopPages';
import { pageRequestConfig, GetPageResults, GetPageVariables } from 'graphql/queries/GetPageData.query';
import {
  pageFilesRequestConfig,
  GetPagesFilesResults,
  GetPagesFilesVariables,
} from 'graphql/queries/GetPagesFiles.query';
import { contactSubjectsRequestConfig, GetContactSubjectsResult } from 'graphql/queries/GetContactSubjects.query';
import { faqRequestConfig, GetFaqResult } from 'graphql/queries/GetFaq.query';
import { GetPageLayoutResult, serverRequests as pageLayoutServerRequests } from '@layouts/PageLayout/PageLayout.utils';
import FaqPage from '@pages/Faq';
import getCommonServerSideProps from 'utils/getCommonServerSideProps';
import { RequestConfig } from 'utils/combineRequest';

const { routes } = config;

const serverRequests: RequestConfig[] = [
  ...pageLayoutServerRequests,
  pageRequestConfig,
  pageFilesRequestConfig,
  faqRequestConfig,
  contactSubjectsRequestConfig,
];

export const getServerSideProps = getCommonServerSideProps<
  GetPageLayoutResult & GetPageResults & GetPagesFilesResults & GetFaqResult & GetContactSubjectsResult,
  GetPageVariables & GetPagesFilesVariables
>(routes.faq.href, serverRequests, { pages: [routes.faq.href] }, (v) => v, itShops);

const Faq = ({ items, contactSubjects }: InferGetServerSidePropsType<typeof getServerSideProps>): JSX.Element => (
  <FaqPage items={items} contactSubjects={contactSubjects} />
);

export default withPageLayout(Faq, { breadcrumbVariant: 'faq', showBreadcrumb: true });
